import { getParamSettingListFetch, modifyParamFetch } from "../../api/api";

const state = {
  paramsettingList: []
}
const actions = {
  async getParamSettingList({ commit }) {
    try {

      const data = await getParamSettingListFetch();
      commit('setParamSettingList', data)

    } catch (e) {
      throw new Error(e);
    }
  },
  async modifyParam({ commit }, { param, cb }) {
    try {

      const data = await modifyParamFetch({ data: JSON.stringify(param) });
      commit('')
      cb(data)

    } catch (e) {
      throw new Error(e);
    }
  }
}
const mutations = {
  setParamSettingList(state, data) {
    state.paramsettingList = data.sysParas
  },

}

export default {
  state,
  actions,
  mutations
}